export const version = 'v2.2.4-2067-g2c3472289'
